import { render, staticRenderFns } from "./Registerv2.vue?vue&type=template&id=c40a75d6"
import script from "./Registerv2.vue?vue&type=script&lang=js"
export * from "./Registerv2.vue?vue&type=script&lang=js"
import style0 from "./Registerv2.vue?vue&type=style&index=0&id=c40a75d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports